import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Render a stored phone number for reading.
 *
 * Numbers are stored in E.164 (`+919876543210`), which is the right thing to
 * store and a poor thing to read — the country code runs straight into the
 * number. This groups it the way that country writes it (`+91 98765 43210`,
 * `+971 50 123 4567`), so the country is visible at a glance in a grid.
 *
 * Anything that will not parse is returned unchanged rather than hidden: a
 * legacy or malformed number should still be visible to whoever has to fix it.
 */
export const formatPhone = (value?: string | null): string => {
  const raw = (value || '').trim();
  if (!raw) return '';
  const parsed = parsePhoneNumberFromString(raw);
  return parsed ? parsed.formatInternational() : raw;
};

export default formatPhone;
